import React, { useState, useEffect, useMemo } from 'react';

import { InputForm } from 'components/inputs';
import { InputTypesActions } from 'stores/inputs/InputTypesStore';
import { InputsActions } from 'stores/inputs/InputsStore';
import useHistory from 'routing/useHistory';
import Routes from 'routing/Routes';
import type { InputDescription } from 'stores/inputs/InputTypesStore';
import type { ConfigurationField } from 'components/configurationforms/types';
import type { ConfiguredInput } from 'components/messageloaders/Types';

export const ExternalDataLakeInputType = 'org.graylog.plugins.datalake.externaldatalake.input.ExternalDataLakeInput';

type Props = {
  connectorId?: string;
  tableId?: string;
  filterQuery?: string;
  filterQueryOperator?: 'AND'|'OR';
  onClose: () => void;
};

const DataLakeConnectorCreateInputModal = ({
  connectorId = undefined,
  tableId = undefined,
  filterQuery = undefined,
  filterQueryOperator = undefined,
  onClose
}: Props) => {
  const history = useHistory();
  const [inputDefinition, setInputDefinition] = useState<InputDescription | undefined>(undefined);

  useEffect(() => {
    InputTypesActions.get(ExternalDataLakeInputType).then((_inputDefinition: InputDescription) => {
      setInputDefinition(_inputDefinition);
    });
  }, []);

  const externalDataLakeInputFields = useMemo(
    () =>
      inputDefinition?.requested_configuration
        ? ({
            ...inputDefinition?.requested_configuration,
            athena_connector: {
              ...inputDefinition?.requested_configuration?.athena_connector,
              default_value: connectorId || inputDefinition?.requested_configuration?.athena_connector?.default_value,
            },
            table_name: {
              ...inputDefinition?.requested_configuration?.table_name,
              default_value: tableId || inputDefinition?.requested_configuration?.table_name?.default_value,
            },
            filter_query: {
              ...inputDefinition?.requested_configuration?.filter_query,
              default_value: filterQuery || inputDefinition?.requested_configuration?.filter_query?.default_value,
            },
            filter_query_operator: {
              ...inputDefinition?.requested_configuration?.filter_query_operator,
              default_value: filterQueryOperator || inputDefinition?.requested_configuration?.filter_query_operator?.default_value,
            },
          } as { [key: string]: ConfigurationField })
        : inputDefinition?.requested_configuration,
    [connectorId, tableId, filterQuery, filterQueryOperator, inputDefinition?.requested_configuration],
  );

  const createInput = (data: ConfiguredInput) => {
    InputsActions.create(data).then(() => {
      onClose();
      history.push(Routes.SYSTEM.INPUTS);
    });
  };

  return (
    <InputForm
      setShowModal={onClose}
      configFields={externalDataLakeInputFields}
      title={
        <span>
          Launch new <em>External Data Lake Filtered Input</em>
        </span>
      }
      description={inputDefinition?.description}
      submitButtonText="Launch Input"
      typeName={ExternalDataLakeInputType}
      handleSubmit={createInput}
    />
  );
};

export default DataLakeConnectorCreateInputModal;
